import { TableRow } from '@shared/UI';
import { IServiceTransferReportDto } from '@shared/api';

interface IOptions {
    onISOReportViewClick: (id: IServiceTransferReportDto) => void;
}

export function getISOReportsTableRows(options: IOptions): TableRow<IServiceTransferReportDto> {
    const { onISOReportViewClick } = options;
    return { onClick: (row) => () => onISOReportViewClick(row) };
}
